require('./hireCardMetallicStep2.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
import { DisclaimerPersonalInfo } from 'components/hire/cardViaT/disclaimerPersonalInfo/disclaimerPersonalInfo';
const HireCardNameSelector = require('components/hire/hireCardNameSelector/hireCardNameSelector');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');
const { formatNumber } = require('utilities/currencyHelper');

// @ constants
const { DEFAULT_LIMIT, SECOND_STEP } = require('constants/index');

class hireCardMetallicStep2 extends React.Component {

    componentDidMount(){
        const {
            immAccounts,
            setAllAccountsToInactive,
            accountsIndexesFiltered,
        } = this.props;

        const allAccountsInactive = hasAllAccountsInactive(accountsIndexesFiltered, immAccounts.get('byId'));
        if(allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    render() {
        const {
            accountsIndexesFiltered,
            handleAccountChange,
            immAccounts,
            immHireCardNameSelector,
            immHireCardMetallic,
            isInactiveAccountsEnabled,
            contracts,
            immMetalCard,
            applyMetalCardValidations
        } = this.props;
        const immStep2 = immHireCardMetallic.getIn(['steps', SECOND_STEP], '');
        const hasInsufficientBalance = immStep2.get('hasInsufficientBalance', false);
        const accountErrorMsgVisible = immStep2.get('accountIsDirty') && !immStep2.get('accountId') || hasInsufficientBalance;
        const limit = !!immMetalCard ? immMetalCard.get("limit") : DEFAULT_LIMIT;
        const accountErrorMsg = hasInsufficientBalance
        ? <FormattedText value="hireCardMetallic-step2AccountLimitError" injectedStrings={[limit]} />
        : formatText('hireCardMetallic-step2SelectAccountError');
        const subLabelElement = applyMetalCardValidations ? <FormattedText value="hireCardMetallic-additionalDescriptionText" injectedStrings={[limit]} /> : null;
        const accountLabel = formatText('hireCardMetallic-step2SelectAccount');
        const disclaimerPersonalInfoUrl = contracts && contracts.get('proteccion_datos', '') || '';
        const tooltipMsgContent = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_dropdownCommonToolTip' : '';
        const handleAccountSelection = (accountId) => {
            const hasInsufficientBalance =
                Number(formatNumber(limit)) >
                Number(immAccounts.getIn(["byId", accountId, "balance", "amount"], ""));
            handleAccountChange({
                accountId,
                hasInsufficientBalance: applyMetalCardValidations ? hasInsufficientBalance : false,
            });
        };
        return (
            <article className="hire-card-metallic-step-two">
                <FormattedText
                    className="hire-card-metallic__step-title"
                    value="hireCardMetallic-step2Title"
                />
                <HireCardNameSelector
                    immHireCardNameSelector={immHireCardNameSelector}
                />
                <DropdownAccounts
                    accountsIndexes={accountsIndexesFiltered}
                    currentAccountId={immStep2.get('accountId')}
                    error={accountErrorMsgVisible}
                    errorMsg={accountErrorMsg}
                    immAccounts={immAccounts.get('byId')}
                    label={accountLabel}
                    onAccountChange={handleAccountSelection}
                    optionalElement={DisclaimerPersonalInfo()}
                    showAvailableBalance
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    subLabelElement={subLabelElement}
                    tooltipMsg={tooltipMsgContent}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                />
                <div className="hire-card-metallic-step-two__disclaimer-personal-info">
                    <OKMessage type="informative">
                        <FormattedText value="disclaimerPersonalInfo-MetallicMsg" />
                        &nbsp;
                        <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                            <FormattedText value="disclaimerPersonalInfo-MetallicLinkText" />
                        </OKLink>
                    </OKMessage>
                </div>
            </article>
        );
    }
}

hireCardMetallicStep2.propTypes = {
    applyMetalCardValidations: PropTypes.bool.isRequired,
    accountsIndexesFiltered: PropTypes.object.isRequired,
    handleAccountChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardMetallic: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    contracts: PropTypes.object.isRequired,
    immMetalCard: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = hireCardMetallicStep2;
